import React, { useCallback, useEffect, useRef, useState } from 'react';
import hot from '../../../img/icons/dietary/Spicy.svg';
import extraHot from '../../../img/icons/dietary/Extra-Spicy.svg';
import CustomiseCardBase from './CustomiseCardBase';
import CustomiseCardPepper from './CustomiseCardPepper';
import CustomiseCardExtra from './CustomiseCardExtra';
import { useSelector } from 'react-redux';
import { getQuickAddProperties } from '../../../helpers/basketHelpers';

const CustomiseCard = ({
  name,
  cardSelect,
  handleIncrease,
  handleDecrease,
  handleIncludedToggle,
  selected,
  selectedQuickAddOption,
  setSelectedQuickAddOption,
  cost,
  parent,
  option,
  isPeppers,
  reachedMax,
  disabled,
  required,
  currentTier,
  loyaltySchemeVersion,
  showCalories,
  canAddForFree,
  setNotification,
  isRadio,
  isDuoRomana,
  handleBaseNameClick,
  handleChoiceModalEdit,
  selectedOptions,
  selectedOptionItemId,
  preSelectedPizza
}) => {
  const calories = (option.product?.calories || option.calories);
  const popupModalIds = useSelector(state => state.session.frontEndConfig?.popupModalIds);
  const [preSelectDone, setPreSelectDone] = useState(false);

  useEffect(() => {
    const selectAsync = async () => {
      if (!preSelectDone && cardSelect && preSelectedPizza && (preSelectedPizza === option.product.id)) {
        await cardSelect(option);
        setPreSelectDone(true);
      }
    };
    selectAsync();
  }, [cardSelect]);

  const handleCardSelect = useCallback(async () => {
    if (isRadio && !disabled && !option.outOfStock && selected?.id !== option?.id) {
      await cardSelect(option);
    }
  }, [option, parent, cardSelect, selected]);

  const isPepperChoice = (option) => {
    // Checks if the option belongs to the 'Choose your pepper' section
    if (!option?.uiTags) return false;
    return (option?.uiTags?.includes('Spicy 1') || option.uiTags?.includes('Spicy 2')) && option.parent.name === 'Choose your pepper';
  };

  const optionHasPeppers = isPepperChoice(option.uiTags) && !isDuoRomana && required;
  const isBase = required && !optionHasPeppers || (optionHasPeppers && isDuoRomana);

  useEffect(() => {
    const { popupRequired } = getQuickAddProperties(option, popupModalIds);
    if (!popupRequired) return;
    if (isDuoRomana && selected) {
      const popupDefaultSubProduct = selectedOptions[selectedOptionItemId + '.please choose.choose your pepper']?.[0]?.id;
      setSelectedQuickAddOption({ id: option.id, selected: popupRequired.subProducts?.find(o => o.id === popupDefaultSubProduct) });
    }
    else {
      setSelectedQuickAddOption();
    }
  }, [selectedOptions])

  return (
    <div className="customise-card-option" onClick={handleCardSelect} style={{ cursor: !isRadio || option.outOfStock ? '' : 'pointer' }}>
      {
        isBase &&
        <CustomiseCardBase
          name={name}
          cost={cost}
          parent={parent}
          option={option}
          selected={selected}
          selectedQuickAddOption={selectedQuickAddOption}
          disabled={disabled || option.outOfStock}
          calories={calories}
          showCalories={showCalories}
          currentTier={currentTier}
          loyaltySchemeVersion={loyaltySchemeVersion}
          isOutOfStock={option.outOfStock}
          isDuoRomana={isDuoRomana}
          handleBaseNameClick={handleBaseNameClick}
          handleChoiceModalEdit={handleChoiceModalEdit}
        />
      }
      {
        optionHasPeppers && required &&
        <CustomiseCardPepper
          name={name}
          parent={parent}
          option={option}
          selected={selected}
          disabled={disabled}
          calories={calories}
          showCalories={showCalories}
          isDuoRomana={isDuoRomana}
          handleBaseNameClick={handleBaseNameClick}
        />
      }
      {
        !required &&
        <CustomiseCardExtra
          name={name}
          cost={cost}
          parent={parent}
          option={option}
          selected={selected}
          isPeppers={isPeppers}
          reachedMax={reachedMax}
          handleIncrease={handleIncrease}
          handleDecrease={handleDecrease}
          handleIncludedToggle={handleIncludedToggle}
          disabled={disabled || option.outOfStock}
          calories={calories}
          showCalories={showCalories}
          isOutOfStock={option.outOfStock}
          canAddForFree={canAddForFree}
          setNotification={setNotification}
        />
      }
    </div>
  );
};

export default CustomiseCard;

export const getPeppers = (uiTags) => {
  if (!uiTags) return null;
  else if (uiTags?.includes('Spicy 1')) {
    return <div className="level-item">
      <img alt="null" src={hot} data-testid='spicy-icon' className="icon" aria-label='spicy' />
    </div>;
  } else if (uiTags?.includes('Spicy 2')) {
    return <div className="level-item">
      <img alt="null" src={extraHot} data-testid='extra-spicy-icon' className="icon" aria-label='extra spicy' />
    </div>;
  } else {
    return null;
  }
};